import instance from '../instance';
import updateChildrenPresence from '../utils/helpers/update-children-presence';
import prepareSerializedStaticDocument from '../utils/helpers/prepare-serialized-static-document';

const setChildrenPresence = (element, childrenPresenceUpdate) => {
  const { childrenSelector, enabled, blockSettingId } = childrenPresenceUpdate;

  updateChildrenPresence(element, childrenSelector, enabled, blockSettingId);

  const clonedStaticDOM = instance.driver.getStaticDocument().cloneNode(true);

  return prepareSerializedStaticDocument(clonedStaticDOM);
};

export default setChildrenPresence;
